import { collectTrackData } from '@/utils/Tracker/tracker';
import { collect } from '@/analytics';

const EVENT = {
  NAME: 'gaEvent',
  CATEGORY: {
    LOGO_BUILDER: 'Logo Builder',
  },
  ACTION: {
    CLICK_BANNER: 'Clique no Banner',
    CLOSE_BANNER: 'Clique no botão - Fechar Banner',
    CLICK_MENU: 'Clique no Menu',
    CLICK_BACK: 'Clique no Botão - Voltar',
    CLICK_CONTINUE_FREE: 'Clique no botão - Continuar no plano grátis',
    CLICK_START_NOW: 'Clique no botão - Começar agora (Plano HostGator Creator)',
    CLICK_CONTINUE_PAYMENT: 'Clique no botão - Continuar para pagamento',
    CLOSE_MODAL: 'Clique no botão - Fechar modal',
    CLICK_CREATE_LOGO: 'Clique no Botão - Criar logo',
    CLICK_OK: 'Clique no botão - ok, entendi',
  },
  LABEL: {
    BANNER: 'Banner - Crie logos profissionais',
    MENU_LOGO_BUILDER: 'Menu - Criador de Logo',
    PLAN_SELECTION: 'Seleção de Planos',
    PAYMENT_HOSTGATOR_CREATOR: 'Pagamento Plano HostGator Creator',
    BRAND_INFO_HOSTGATOR_CREATOR: 'Formulário de informações sobre a marca - HostGator Creator',
    BRAND_INFO_FREE_PLAN: 'Formulário de informações sobre a marca - Plano Grátis',
    LOGO_REQUESTED: 'Logo solicitado',
    FORM_ERROR: 'Erro no formulário',
  },
};

const events = {
  bannerClick: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLICK_BANNER,
    label: EVENT.LABEL.BANNER,
  },
  bannerClose: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLOSE_BANNER,
    label: EVENT.LABEL.BANNER,
  },
  menuClick: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLICK_MENU,
    label: EVENT.LABEL.MENU_LOGO_BUILDER,
  },
  planSelectionContinueFree: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLICK_CONTINUE_FREE,
    label: EVENT.LABEL.PLAN_SELECTION,
  },
  planSelectionStartNow: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLICK_START_NOW,
    label: EVENT.LABEL.PLAN_SELECTION,
  },
  paymentContinue: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLICK_CONTINUE_PAYMENT,
    label: EVENT.LABEL.PAYMENT_HOSTGATOR_CREATOR,
  },
  paymentCloseModal: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLOSE_MODAL,
    label: EVENT.LABEL.PAYMENT_HOSTGATOR_CREATOR,
  },
  brandInfoCloseModal: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLOSE_MODAL,
    label: EVENT.LABEL.BRAND_INFO_HOSTGATOR_CREATOR,
  },
  brandInfoBack: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLICK_BACK,
    label: EVENT.LABEL.BRAND_INFO_HOSTGATOR_CREATOR,
  },
  brandInfoCreateLogo: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLICK_CREATE_LOGO,
    label: EVENT.LABEL.BRAND_INFO_HOSTGATOR_CREATOR,
  },
  brandInfoCloseModalFree: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLOSE_MODAL,
    label: EVENT.LABEL.BRAND_INFO_FREE_PLAN,
  },
  brandInfoBackFree: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLICK_BACK,
    label: EVENT.LABEL.BRAND_INFO_FREE_PLAN,
  },
  brandInfoCreateLogoFree: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLICK_CREATE_LOGO,
    label: EVENT.LABEL.BRAND_INFO_FREE_PLAN,
  },
  formError: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLICK_CREATE_LOGO,
    label: EVENT.LABEL.FORM_ERROR,
  },
  logoRequestedCloseModal: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLOSE_MODAL,
    label: EVENT.LABEL.LOGO_REQUESTED,
  },
  logoRequestedOk: {
    campaign: EVENT.CATEGORY.LOGO_BUILDER,
    action: EVENT.ACTION.CLICK_OK,
    label: EVENT.LABEL.LOGO_REQUESTED,
  },
};

const bannerClick = () => {
  collect({
    event: 'gaEvent',
    ...events.bannerClick,
  });
  collectTrackData(events.bannerClick);
};

const bannerClose = () => {
  collect({
    event: 'gaEvent',
    ...events.bannerClose,
  });
  collectTrackData(events.bannerClose);
};

const menuClick = () => {
  collect({
    event: 'gaEvent',
    ...events.menuClick,
  });
  collectTrackData(events.menuClick);
};

const planSelectionContinueFree = () => {
  collect({
    event: 'gaEvent',
    ...events.planSelectionContinueFree,
  });
  collectTrackData(events.planSelectionContinueFree);
};

const planSelectionStartNow = () => {
  collect({
    event: 'gaEvent',
    ...events.planSelectionStartNow,
  });
  collectTrackData(events.planSelectionStartNow);
};

const paymentContinue = () => {
  collect({
    event: 'gaEvent',
    ...events.paymentContinue,
  });
  collectTrackData(events.paymentContinue);
};

const paymentCloseModal = () => {
  collect({
    event: 'gaEvent',
    ...events.paymentCloseModal,
  });
  collectTrackData(events.paymentCloseModal);
};

const brandInfoCloseModal = () => {
  collect({
    event: 'gaEvent',
    ...events.brandInfoCloseModal,
  });
  collectTrackData(events.brandInfoCloseModal);
};

const brandInfoBack = () => {
  collect({
    event: 'gaEvent',
    ...events.brandInfoBack,
  });
  collectTrackData(events.brandInfoBack);
};

const brandInfoCreateLogo = () => {
  collect({
    event: 'gaEvent',
    ...events.brandInfoCreateLogo,
  });
  collectTrackData(events.brandInfoCreateLogo);
};

const brandInfoCloseModalFree = () => {
  collect({
    event: 'gaEvent',
    ...events.brandInfoCloseModalFree,
  });
  collectTrackData(events.brandInfoCloseModalFree);
};

const brandInfoBackFree = () => {
  collect({
    event: 'gaEvent',
    ...events.brandInfoBackFree,
  });
  collectTrackData(events.brandInfoBackFree);
};

const brandInfoCreateLogoFree = () => {
  collect({
    event: 'gaEvent',
    ...events.brandInfoCreateLogoFree,
  });
  collectTrackData(events.brandInfoCreateLogoFree);
};

const formError = () => {
  collect({
    event: 'gaEvent',
    ...events.formError,
  });
  collectTrackData(events.formError);
};

const logoRequestedCloseModal = () => {
  collect({
    event: 'gaEvent',
    ...events.logoRequestedCloseModal,
  });
  collectTrackData(events.logoRequestedCloseModal);
};

const logoRequestedOk = () => {
  collect({
    event: 'gaEvent',
    ...events.logoRequestedOk,
  });
  collectTrackData(events.logoRequestedOk);
};

const analytics = {
  bannerClick,
  bannerClose,
  menuClick,
  planSelectionContinueFree,
  planSelectionStartNow,
  paymentContinue,
  paymentCloseModal,
  brandInfoCloseModal,
  brandInfoBack,
  brandInfoCreateLogo,
  brandInfoCloseModalFree,
  brandInfoBackFree,
  brandInfoCreateLogoFree,
  formError,
  logoRequestedCloseModal,
  logoRequestedOk,
};

export default analytics;
